import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row-reverse justify-center items-center" }
const _hoisted_2 = { class: "flex-grow-0 w-full lg:w-10/12" }
const _hoisted_3 = { class: "my-form border-double border-2 rounded-lg" }
const _hoisted_4 = {
  key: 0,
  class: "my-form--field"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Trattamento", -1)
const _hoisted_6 = { class: "my-form--field--label" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  class: "my-form--field"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Tenuta", -1)
const _hoisted_10 = { class: "my-form--field--label" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 2,
  class: "my-form--field"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Pressione", -1)
const _hoisted_14 = { class: "my-form--field--label" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 3,
  class: "my-form--field"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Manipolo", -1)
const _hoisted_18 = { class: "my-form--field--label" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 4,
  class: "my-form--field"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Zona", -1)
const _hoisted_22 = { class: "my-form--field--label" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 5,
  class: "my-form--field"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Durata", -1)
const _hoisted_26 = { class: "my-form--field--label" }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 6,
  class: "my-form--field"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Potenza", -1)
const _hoisted_30 = { class: "my-form--field--label" }
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 7,
  class: "my-form--field"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Morfologia", -1)
const _hoisted_34 = { class: "my-form--field--label" }
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 8,
  class: "my-form--field"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Genere", -1)
const _hoisted_38 = { class: "my-form--field--label" }
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 9,
  class: "my-form--field"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Modalità di lavoro", -1)
const _hoisted_42 = { class: "my-form--field--label" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "my-form--field" }
const _hoisted_45 = { class: "my-form--field--field" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Salva seduta ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ($props.tipoMacchina === 'XP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.sedutaProgrammata.trattamento) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.trattamentoXPOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.trattamento]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($props.tipoMacchina === 'XP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.sedutaProgrammata.tenuta) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tenutaOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_11))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.tenuta]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($props.tipoMacchina === 'XP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.sedutaProgrammata.pressione) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pressioneOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.pressione]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($props.tipoMacchina !== 'XP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.sedutaProgrammata.manip) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getManipoloOptions(), (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_19))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.manip]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!$options.hideZonaField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.sedutaProgrammata.zona) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getZonaOptions(), (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.zona]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($options.showDurataField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.sedutaProgrammata.durata) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getDurataOptions(), (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_27))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.durata]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($options.showPotenzaField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.sedutaProgrammata.potenza) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.potenzaOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_31))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.potenza]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($options.showMorfologiaGenereField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.sedutaProgrammata.morfologia) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.morfologiaOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_35))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.morfologia]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($options.showMorfologiaGenereField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.sedutaProgrammata.genere) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.genereOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_39))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.genere]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($options.showModalitaLavoroField())
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.sedutaProgrammata.modalitalavoro) = $event)),
                  class: "my-input"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.modalitaLavoroXTOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_43))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $data.sedutaProgrammata.modalitalavoro]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_Button, {
              class: "is-secondary",
              icon: "fas fa-upload",
              onClick: $options.salvaSeduta
            }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
}